'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withFiltersCurrent = undefined;

var _recompose = require('recompose');

var withFiltersCurrent = exports.withFiltersCurrent = function withFiltersCurrent(Component) {
  return (0, _recompose.compose)((0, _recompose.withHandlers)({
    onClearAll: function onClearAll(_ref) {
      var changeFilters = _ref.changeFilters;
      return function (event) {
        event.preventDefault();
        changeFilters();
      };
    },
    onClearFilter: function onClearFilter(_ref2) {
      var changeFilters = _ref2.changeFilters;
      return function (filterId) {
        return function (event) {
          event.preventDefault();
          changeFilters(filterId);
        };
      };
    },
    onClearFilterValue: function onClearFilterValue(_ref3) {
      var changeFilters = _ref3.changeFilters;
      return function (filterId, filterValueId) {
        return function (event) {
          event.preventDefault();
          changeFilters(filterId, filterValueId);
        };
      };
    }
  }))(Component);
};


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/vx-filters-current/with-filters-current.js
// module id = 2033
// module chunks = 0